var MapHelper = (function ($, _) {

	/**
	 * Calculate scale of map in meters
	 * @param { LatLngBounds: Constructs a rectangle from the points at its south-west and north-east corners. } bounds 
	 * @returns { scale of map in meters } 
	 */
	var _getRadius = function (bounds) {
		var r = 6378.8;
		var ne_lat = bounds.getNorthEast().lat() / 57.2958;
		var ne_lng = bounds.getNorthEast().lng() / 57.2958;
		var c_lat = bounds.getCenter().lat() / 57.2958;
		var c_lng = bounds.getCenter().lng() / 57.2958;
		var r_km = r *
			Math.acos(
				Math.sin(c_lat) * Math.sin(ne_lat) +
				Math.cos(c_lat) * Math.cos(ne_lat) * Math.cos(ne_lng - c_lng)
			);
		return parseInt(r_km * 1000);
	};

	var _initializeGoogleapis = function (key) {
		return $.getScript('https://maps.googleapis.com/maps/api/js?key=' + key);
	};

	var _initializeMap = function (mapCanvas, s) {
		var mapOptions = {
			zoom: s.z,
			center: s.location,
			disableDefaultUI: true,
			zoomControl: true,
			zoomControlOptions: {
			    position: google.maps.ControlPosition.TOP_RIGHT
			},
			scaleControl: true
		};
		return new google.maps.Map(mapCanvas, mapOptions);
	}

	var _getCountrySettings = function(countryID) {
		switch (countryID) {
			case 'AU':
				return {
					location: {
						lat: -33,
						lng: 146
					},
					z: 5
				};
			case 'NZ':
				return {
					location: {
						lat: -41,
						lng: 169
					},
					z: 5
				};
			default:
				return {
					location: {
						lat: -33,
						lng: 146
					},
					z: 5
				};
		}
	}

	/**
	 * Map Helper
	 * @param {dom element - container for map object } mapCanvas 
	 * @param {google maps api token} key 
	 * @param {current country id (iso-code)} countryID 
	 * @param {called after map position was change (function)} coordinates_changed 
	 * @param {get html template for info window (function)} getMarkerInfoHtml 
	 * @param {called after marker was selected (function)} currentChanged 
	 * @returns {Map Helper object} 
	 */
	function map(mapCanvas, key, countryID, coordinates_changed, getMarkerInfoHtml, currentChanged) {

		this.$ready = new $.Deferred();

		this._markers = [];

		this.coordinates_changed = coordinates_changed || this.coordinates_changed;
		this.getMarkerInfoHtml = getMarkerInfoHtml || this.getMarkerInfoHtml;
		this.currentChanged = currentChanged || this.currentChanged;


        _initializeGoogleapis(key)
			.done(_.bind(function (location) {
				this.settings = _getCountrySettings(countryID);
				this._map = _initializeMap(mapCanvas, this.settings);
                this._map.addListener('dragend', _.bind(this._subscribeOnMapEvents, this));
                this._infowindow = new google.maps.InfoWindow({ maxWidth: 190 });

                google.maps.event.addListener(this._infowindow, 'domready',
                    _.bind(function () {
                        this._unsubscribeOnMapEvents();
                        var position = this._infowindow.getPosition();
                        this._map.setCenter(position);
                    }, this));

                this.$ready.resolve();
            }, this))
            .fail(this.$ready.reject);

	}

	map.prototype = {

		ready: function () {
			return this.$ready.promise();
		},

		_subscribeOnMapEvents: function () {
			this._map.addListener('idle', _.bind(this._coordinates_changed, this));
		},

		_unsubscribeOnMapEvents: function () {
			google.maps.event.clearListeners(this._map, 'idle');
		},

		_coordinates_changed: function () {

			var bounds = this._map.getBounds();

			var coordinates = this._map.getCenter().toJSON();
			coordinates.radius = _getRadius(bounds);

			this.coordinates_changed(coordinates);
		},

		coordinates_changed: function (coordinates) {
			throw new Error('You must define method coordinates_changed!');
		},

		getMarkerInfoHtml: function () {
			throw new Error('You must define method coordinates_changed!');
		},

		currentChanged: function () {
			throw new Error('You must define method currentChanged!');
		},

		resize: function () {

			google.maps.event.trigger(this._map, 'resize');

			if (this.updatePossition) {

				if (!!this._markers.length && this._bounds) {
					if (!this._bounds.isEmpty()) {

						if (this._bounds.getNorthEast().equals(this._bounds.getSouthWest())) {
							var extendPoint = new google.maps.LatLng(this._bounds.getNorthEast().lat() + 0.001, this._bounds.getNorthEast().lng() - 0.001);
							this._bounds.extend(extendPoint);
						}

						/* auto zoom */
						this._map.fitBounds(this._bounds);

						/* auto center */
						this._map.panToBounds(this._bounds);
					}
				} else {
					var _map = this._map;
					var _s = this.settings;
					setTimeout(function () {
						_map.setCenter(_s.location);
						_map.setZoom(_s.z);
					}, 0)
				}
				this.updatePossition = false;
			}

		},

		addMarkers: function (pickupPoints) {
			this._unsubscribeOnMapEvents();
			this._removeMarkers();
			this._bounds = new google.maps.LatLngBounds();
			for (var i = 0; i < pickupPoints.length; i++) {
                pickupPoints[i] && this._addMarker(pickupPoints[i]);
			}
		},

		_removeMarkers: function () {
			for (var i = 0; i < this._markers.length; i++) {
				this._markers[i].setMap(null);
			}
			this._markers = [];
		},

		_getIcon: function (service, isSelected) {
			var url = 'https://c1.mysalec.com/pickup-points/pp-marker-{0}{1}.png';
			url = url.replace(/\{0\}/, service);
			url = url.replace(/\{1\}/, (isSelected && '-selected') || '');
			return url;
		},

		_addMarker: function (data) {
			var marker = new google.maps.Marker({
				position: {
					lat: parseFloat(data.Latitude),
					lng: parseFloat(data.Longitude)
				},
				icon: this._getIcon(data.PostServiceId, false),
				map: this._map,
				title: data.Name,
				pickupPointID: data.ID,
				type: data.PostServiceId
			});

            marker.addListener('click', _.bind(function () {
                if (window.__isMobile__) {
                    window.app && app.event && app.event.choosePickupPoint();
                }
                this.setCurrent(data, true);
                this.currentChanged(data);
            }, this));

			/* auto center */
			this._markers.push(marker);
			var loc = new google.maps.LatLng(marker.getPosition().toJSON());
			this._bounds.extend(loc);
			return marker;
		},

		_displayInfo: function (marker, data) {
			this._infowindow.setContent(this.getMarkerInfoHtml(data));
			this._infowindow.open(this._map, marker);
		},

		_getMarkerByPickupPointID: function (id) {
			var marker = null;
			for (var i = 0; i < this._markers.length; i++) {
				if (this._markers[i].pickupPointID === id) {
					marker = this._markers[i];
					break;
				}
			}
			return marker;
		},

		setCurrent: function (data, displayInfo) {

			!displayInfo && this._unsubscribeOnMapEvents();
			var marker = this._getMarkerByPickupPointID(data.ID);

			this._currentMarker && this._currentMarker.setIcon(this._getIcon(this._currentMarker.type, false));
			this._currentMarker && this._currentMarker.setZIndex(0);

			if (marker) {
				this._currentMarker = marker;
				this._currentMarker.setIcon(this._getIcon(data.PostServiceId, true));
				this._currentMarker.setZIndex(10000);
				displayInfo && this._displayInfo(this._currentMarker, data);
			}

		}
	}

	return map;

})(jQuery, _);